module.exports = __webpack_public_path__ + "media/images/emblems/Amden_SG_flago-09d995b5b2f76b3a90b7bf390d31d8bb.png";